import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
} from "reactstrap"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  getAwardsCategoryList,
  getNominationDetails,
  updateNomination,
} from "../../../redux/actions/awards"
import { useLocation, useNavigate } from "react-router-dom"
import SuccessPopup from "components/SuccessPopup"
import { UPDATE_NOMINATION_RESET } from "../../../redux/types/awards"
import { toast } from "react-toastify"
import InfoPopup from "components/InfoPopup"

const useQuery = () => new URLSearchParams(useLocation().search)

const EditNomination = () => {
  const query = useQuery()
  const nominationId = query.get("id")
  const dispatch = useDispatch()
  const history = useNavigate()

  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewFile, setPreviewFile] = useState(null)
  const [categoryOptions, setCategoryOptions] = useState(null)
  const [category, setCategory] = useState(null)
  const [status, setStatus] = useState(null)
  const [statusError, setStatusError] = useState(null)
  const [successOpen, setSuccessOpen] = useState(false)
  const statusOptions = [
    { label: "Shortlist", value: "shortlisted" },
    { label: "Reject", value: "rejected" },
  ]

  const nominationDetails = useSelector(state => state.awards.nominationDetails)
  const categoryList = useSelector(state => state.awards.awardCategoryList)
  const updateNominationScreen = useSelector(
    state => state.screens.awards.updateNomination
  )

  useEffect(() => {
    dispatch(getNominationDetails(nominationId))
  }, [])

  useEffect(() => {
    if (updateNominationScreen.success) {
      toast.success(updateNominationScreen.message)
      dispatch({ type: UPDATE_NOMINATION_RESET })
      setSuccessOpen(true)
    }
    if (updateNominationScreen.error) {
      toast.error(updateNominationScreen.error)
      dispatch({ type: UPDATE_NOMINATION_RESET })
    }
  }, [updateNominationScreen])

  useEffect(() => {
    if (nominationDetails && categoryList.length > 0) {
      let tempCategoryOption = []
      categoryList.map(option => {
        tempCategoryOption.push({
          label: option.category,
          value: option.enc_awd_cat_id,
        })
      })
      let foundCategory = tempCategoryOption.find(
        value => value.label === nominationDetails.category_title
      )
      setCategory(foundCategory)
      setCategoryOptions(tempCategoryOption)
    }
    if (
      nominationDetails &&
      (nominationDetails.status === "shortlisted" ||
        nominationDetails.status === "s2_paid")
    ) {
      setStatus({ label: "Shortlist", value: "shortlisted" })
    } else if (
      nominationDetails &&
      (nominationDetails.status === "rejected" ||
        nominationDetails.status === "s2_paid")
    ) {
      setStatus({ label: "Reject", value: "rejected" })
    }
  }, [nominationDetails, categoryList])

  const openPreview = (path, label) => {
    console.log("openPreview opened...", path, label)

    setPreviewFile({
      url: path,
      name: label,
      type: "image/jpeg",
    })
    setPreviewOpen(true)
  }

  const closePreview = () => {
    setPreviewOpen(false)
    setPreviewFile(null)
  }

  const onSubmit = () => {
    if (status) {
      setStatusError(null)
      dispatch(
        updateNomination({
          enc_award_nomination_id: nominationId,
          enc_awd_cat_id: category.value,
          status:
            nominationDetails &&
            (nominationDetails.status === "s2_paid" ||
              nominationDetails.status === "shortlisted" ||
              nominationDetails.status === "rejected")
              ? nominationDetails.status
              : status.value, // shortlisted, rejected
        })
      )
    } else {
      setStatusError("Status is required")
      return
    }
  }

  document.title = "Nominee Details | PULA"
  return (
    <div className="page-content">
      {nominationDetails ? (
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between mb-3"></div>

          {/* Nominee Details */}
          <Card>
            <CardBody>
              <div>
                <h4 className="font-size-18 mb-3 mt-3">Nominee Details</h4>
                <div className="border-top mt-3 pb-4 mb-1"></div>
                <Form>
                  <div className="row">
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="keywords">
                          Nominee Name
                        </Label>
                        <Input
                          name="nominee_name"
                          className="form-control"
                          placeholder="Enter Nominee Name"
                          value={nominationDetails.full_name}
                          type="text"
                          id="nominee_name"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="email">
                          Email
                        </Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Email"
                          value={nominationDetails.email_id}
                          type="email"
                          id="email"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="whatsapp">
                          Whatsapp Number
                        </Label>
                        <Input
                          name="whatsapp"
                          className="form-control"
                          placeholder="Enter Whatsapp Number"
                          value={nominationDetails.wa_mobile_no}
                          type="tel"
                          id="whatsapp"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="contact">
                          Contact Number
                        </Label>
                        <Input
                          name="contact"
                          className="form-control"
                          placeholder="Enter Contact Number"
                          value={nominationDetails.contact_no}
                          type="tel"
                          id="contact"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="whatsapp">
                          State
                        </Label>
                        <Input
                          name="state"
                          className="form-control"
                          placeholder="Enter State"
                          value={nominationDetails.state}
                          type="text"
                          id="state"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="whatsapp">
                          City
                        </Label>
                        <Input
                          name="whatsapp"
                          className="form-control"
                          placeholder="Enter Whatsapp Number"
                          value={nominationDetails.city}
                          type="tel"
                          id="whatsapp"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="contact">
                          Age
                        </Label>
                        <Input
                          name="age"
                          className="form-control"
                          placeholder="Enter Age"
                          value={nominationDetails.age}
                          // type="number"
                          id="age"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="whatsapp">
                          Food Preference
                        </Label>
                        <Input
                          name="foodPreference"
                          className="form-control"
                          placeholder="Enter Food Preference"
                          value={nominationDetails.food_preference_label}
                          type="text"
                          id="foodPreference"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                  <h4 className="font-size-18 mb-3 mt-4">
                    Business / Organisation Details
                  </h4>
                  <div className="border-top mt-3 pb-4 mb-1"></div>
                  <div className="row">
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="pvsCardNumber">
                          PVS Card Number
                        </Label>
                        <Input
                          name="pvsCardNumber"
                          className="form-control"
                          placeholder="Enter PVS Card Number"
                          value={nominationDetails.pvs_card_number}
                          type="text"
                          id="pvsCardNumber"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="businessName">
                          Business Name
                        </Label>
                        <Input
                          name="businessName"
                          className="form-control"
                          placeholder="Enter Business Name"
                          value={nominationDetails.business_name}
                          type="text"
                          id="businessName"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label
                          className="form-label"
                          htmlFor="yearOfEstablishment"
                        >
                          Year of Establishment
                        </Label>
                        <Input
                          name="yearOfEstablishment"
                          className="form-control"
                          placeholder="Enter Year of Establishment"
                          value={nominationDetails.establishment_year}
                          type="number"
                          id="yearOfEstablishment"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="contact">
                          Type of Company
                        </Label>
                        <Input
                          name="companyType"
                          className="form-control"
                          placeholder="Enter Company Type"
                          value={nominationDetails.company_type_label}
                          type="text"
                          id="companyType"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="whatsapp">
                          Nature of Business
                        </Label>
                        <Input
                          name="natureOfBusiness"
                          className="form-control"
                          placeholder="Enter Nature of Business"
                          value={nominationDetails.business_nature_label}
                          type="text"
                          id="natureOfBusiness"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12  mb-4">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="description">
                          Description
                        </Label>
                        <textarea
                          className="form-control"
                          id="description"
                          rows="5"
                          placeholder="Enter Description"
                          value={nominationDetails.business_description}
                          disabled
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 mb-4">
                      <div className="form-group">
                        <Label
                          className="form-label"
                          htmlFor="nominationReason"
                        >
                          Reason of nomination
                        </Label>
                        <textarea
                          className="form-control"
                          id="nominationReason"
                          rows="5"
                          placeholder="Enter Reason for Nomination"
                          value={nominationDetails.nomination_reason}
                          disabled
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <h4 className="font-size-18 mb-3 mt-4">Social Links</h4>
                  <div className="border-top mt-3 pb-4 mb-1"></div>
                  <div className="row">
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="pvsCardNumber">
                          Website
                        </Label>
                        <Input
                          name="website"
                          className="form-control"
                          placeholder="Enter Website URL"
                          value={nominationDetails.website_link}
                          type="text"
                          id="website"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="businessName">
                          Instagram
                        </Label>
                        <Input
                          name="instagram"
                          className="form-control"
                          placeholder="Enter Instagram URL"
                          value={nominationDetails.insta_link}
                          type="text"
                          id="instagram"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label
                          className="form-label"
                          htmlFor="yearOfEstablishment"
                        >
                          Facebook
                        </Label>
                        <Input
                          name="facebook"
                          className="form-control"
                          placeholder="Enter Facebook URL"
                          value={nominationDetails.fb_link}
                          type="text"
                          id="facebook"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="pvsCardNumber">
                          LinkedIn
                        </Label>
                        <Input
                          name="linkedin"
                          className="form-control"
                          placeholder="Enter LinkedIn URL"
                          value={nominationDetails.linkedin_link}
                          type="text"
                          id="linkedin"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="businessName">
                          Youtube
                        </Label>
                        <Input
                          name="youtube"
                          className="form-control"
                          placeholder="Enter Youtube URL"
                          value={nominationDetails.youtube_link}
                          type="text"
                          id="youtube"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <h4 className="font-size-18 mb-3 mt-4">Documents</h4>
                  <div className="border-top mt-3 pb-4 mb-1"></div>
                  <table className="pula-doc-table">
                    <thead>
                      <tr>
                        <th>Document</th>
                        <th className="text-center">Preview</th>
                        <th className="text-center">Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        {
                          label: "Profile Image",
                          path: nominationDetails.user_profile_image_url,
                        },
                        {
                          label: "Award Banner Image",
                          path: nominationDetails.award_user_photo_url,
                        },
                      ].map((doc, index) => (
                        <tr key={index}>
                          <td>{doc.label}</td>

                          {doc.path ? (
                            <>
                              <td className="text-center">
                                <Button
                                  className="pula-icon-btn"
                                  onClick={() => {
                                    openPreview(doc.path, doc.label)
                                  }}
                                >
                                  <i className="ion ion-md-eye"></i>
                                </Button>
                              </td>

                              <td className="text-center">
                                <Button
                                  className="pula-icon-btn"
                                  onClick={() => {
                                    handleDownload(
                                      doc.path,
                                      `${doc.label.replace(/\s+/g, "_")}.jpg`
                                    )
                                  }}
                                >
                                  <i className="ion ion-md-download"></i>
                                </Button>
                              </td>
                            </>
                          ) : (
                            <td
                              colSpan={2}
                              className="text-center text-muted fst-italic"
                            >
                              Not yet added
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <br />
                  <div className="border-top mt-3 pb-4 mb-1"></div>
                  <div className="row">
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="contact">
                          Award Category&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Select
                          id="awards_category"
                          name="awards_category"
                          options={categoryOptions}
                          value={category}
                          onChange={val => {
                            setCategory(val)
                          }}
                          classNamePrefix="select2-selection"
                          className="customselect"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="whatsapp">
                          Action&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Select
                          id="status"
                          name="status"
                          options={statusOptions}
                          value={status}
                          onChange={val => {
                            setStatus(val)
                          }}
                          classNamePrefix="select2-selection"
                          className="customselect"
                          isDisabled={
                            nominationDetails &&
                            (nominationDetails.status === "s2_paid" ||
                              nominationDetails.status === "shortlisted" ||
                              nominationDetails.status === "rejected")
                          }
                        />
                        {statusError && (
                          <FormFeedback className="d-block" type="invalid">
                            {statusError}
                          </FormFeedback>
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </CardBody>
          </Card>

          <div className="d-flex justify-content-center mt-4">
            <Button
              type="submit"
              color="primary"
              className="w-20 btn btn-block font-size-16 mt-3"
              onClick={onSubmit}
            >
              Submit
            </Button>
          </div>
        </div>
      ) : null}
      <SuccessPopup
        isOpen={successOpen}
        toggle={() => setSuccessOpen(!successOpen)}
        onConfirm={() => {
          setSuccessOpen(false)
          history(-1)
        }}
        message={"Nomination Updated successfully!"}
      />
      <InfoPopup
        isOpen={previewOpen}
        toggle={closePreview}
        title="Document Preview"
        previewFile={previewFile}
        btnClass="btn-primary"
      />
    </div>
  )
}

export default EditNomination
